// Autofocus is intentional
/* eslint-disable jsx-a11y/no-autofocus */
import React, { forwardRef, useRef } from 'react';
import { useOverlay } from '@react-aria/overlays';
import { useDialog } from '@react-aria/dialog';
import { FocusScope } from '@react-aria/focus';
import useMergedRef from '@react-hook/merged-ref';
import { pickAriaProps } from '../../../interfaces/commonProps';
import { Overlay } from '../Overlay';
import { StyledTray, StyledTrayContainer } from './Tray.styles';
const TrayContainer = forwardRef(function TrayContainer({ children, open, onClose, autoFocus, ...restProps }, ref) {
    const trayRef = useRef(null);
    const getRef = useMergedRef(ref, trayRef);
    const { overlayProps } = useOverlay({
        onClose,
        isOpen: open,
        isDismissable: true,
    }, trayRef);
    const { dialogProps } = useDialog(pickAriaProps(restProps), trayRef);
    return (React.createElement(FocusScope, { contain: true, restoreFocus: true, autoFocus: autoFocus },
        React.createElement(StyledTrayContainer, null,
            React.createElement(StyledTray, { open: open, ...restProps, ...overlayProps, ...dialogProps, ref: getRef }, children))));
});
export const Tray = forwardRef(function Tray({ children, autoFocus = false, ...restProps }, ref) {
    const { open } = restProps;
    return (React.createElement(Overlay, { open: open, transitionDuration: 250, backdrop: true },
        React.createElement(TrayContainer, { ref: ref, autoFocus: autoFocus, ...restProps }, children)));
});
//# sourceMappingURL=Tray.js.map